import { ChangeRequestModel } from './ChangeRequestModel';
import './InsuranceChangeRequest.css';
import { useEffect, useRef, useState } from 'react';
import { Textarea } from '@material-tailwind/react';
import 'react-toastify/dist/ReactToastify.css';
import {  useFormik } from 'formik';
import * as Yup from 'yup'
import ChangeRequestConfirmation from './ChangeRequestConfirmation';

const initialValues = {
  answerId: 0,
  credentialRequestId: 0,
  comment: '',
  id: 0,
  resolved: true,
}

const chnageRequestsSchema = Yup.object({
  comment: Yup.string()
  //   .min(3, 'Name must be at least 3 characters')
  //   .max(100, 'Name cannot exceed 40 characters')
  // .matches(/^[a-zA-Z ]*$/, 'Enter a valid name')
})
function ChangeRequestItem({
  data,
  isOpen,
  btnOnClick,
  getChangeRequestsData,
}: {
  data: ChangeRequestModel;
  isOpen: boolean;
  btnOnClick: () => void;
  getChangeRequestsData: any;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [isOpenConfirmPopUp, setIsOpenConfirmPopUp] = useState(false);
  const [selectedComment, setSelectedComment] = useState([{}]);
  const [, setIsPopUpOpen] = useState(false);

  useEffect(() => {
    setIsOpenConfirmPopUp(false);
    if (isOpen) {
      const contentEl = contentRef.current as HTMLDivElement;
      setHeight(contentEl?.scrollHeight ?? 0);
    } else {
      setHeight(0);
    }
  }, [isOpen, data]);


  const { handleSubmit, setFieldValue, resetForm } = useFormik({
    initialValues: initialValues,
    validationSchema: chnageRequestsSchema,
    onSubmit: (values) => {
      //btnOnClickResolve(values)
      setIsOpenConfirmPopUp(true);
      setIsPopUpOpen(true);
      let payload = [{
        id: data.id,
        comment: values.comment,
        resolved: true
      }]
      setSelectedComment(payload)
      resetForm()
    },
  })

  const stateManager = () => {
    setIsPopUpOpen(false)
    setIsOpenConfirmPopUp(false);
  }

  return (
    <><form className='mt-3' onSubmit={handleSubmit}>
      <li className={`accordion-item mb-3 ${isOpen ? 'active' : ''}`}>

        <h2 className="accordion-item-title">
          <button type='button' className="accordion-item-btn" onClick={btnOnClick}>
            <span className='text-sm flex items-center justify-between w-full gap-3'>
              <h1 className='text-xl text-left'>{data.questionPrompt}</h1>
              <span
                className={`shrink-0 px-3 py-1 rounded-full text-xs font-semibold tracking-wide whitespace-nowrap ${data.resolved === true
                  ? 'bg-green-100 text-green-800 ring-1 ring-inset ring-green-300'
                  : 'bg-orange-100 text-orange-800 ring-1 ring-inset ring-orange-300'
                  }`}
              >
                {data.resolved === true ? 'RESOLVED' : 'PENDING'}
              </span>
            </span>
          </button>
        </h2>

        <div className="accordion-item-container" style={{ height }}>
          <div ref={contentRef}>
            <div className='accordion-item-content grid grid-cols-2 gap-4'>

              <div className="bg-gray-50 rounded-md p-3">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">Answer</p>
                <p className="text-sm text-[#222222]">{data.answerText}</p>
              </div>

              <div className="">
                <Textarea
                  label="Comment"
                  defaultValue={data.comment}
                  onChange={(text) => { setFieldValue('comment', text.target.value); }}
                  disabled={data.resolved == true ? true : false} />
              </div>
            </div>

            <div className='w-full border-t border-[#ccc] py-2'>
              <button
                className={`rounded-sm float-right font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 ${data.resolved === true
                  ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                  : 'bg-[#2196f3] text-white hover:bg-blue-600'
                  }`}
                type="submit"
                disabled={data.resolved == true ? true : false}>
                Resolve
              </button>
            </div>
          </div>
        </div>
      </li>
    </form>
      <ChangeRequestConfirmation
        isOpen={isOpenConfirmPopUp}
        data={selectedComment}
        stateManager={stateManager}
        getChangeRequestsData={getChangeRequestsData} /></>
  );
}

export default ChangeRequestItem;